import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import { default as Select } from "../../../components/Select/Select";
import SplitButton from "../../../components/SplitButtion";
import { soapApi } from "../../../redux/actions/api";
import {
  deleteStockById,
  deleteStockByIds,
  getLocations,
  getPendingStocksByClinic,
  getStocksByClinic,
  updateStockFilesById,
  updateStocks,
} from "../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { AppColors } from "../../../util/AppColors";
import {
  administeredUOMList,
  dosageTypes,
  drugScheduleList,
  productCategoryList,
} from "../../../util/dropList";
import { getExactNumber, normalizeDate } from "../../../util/function";
import { tblGrayBack } from "../../../util/object";
import FilesWithCloseButton from "../ClinicPetDetails/PatientWorkbook/FilesWithCloseButton";

const requiredFieldList = [
  "category",
  "subCategory",
  "name",
  "tradeName",
  // "code",
  "location",
  "unitSellingPrice",
  "quantity",
  // "adminUom",
  // "landedCost",
  "cgst",
  "sgst",
  "itemTotal",
];

const nmeExpan = {
  hsnSacCode: "HSN/SAC Code",
  name: "Name",
  quantity: "Qty",
  landedCost: "Landed Cost",
  cgst: "CGST %",
  sgst: "SGST %",
  taxes: "Taxes",
  itemTotal: "Item Total",
  purchaseUom: "UOM",
};

const initStckVal = { supplierName: null, date: new Date(), list: [] };
const initialValues = {
  category: null,
  subCategory: "",
  name: "",
  tradeName: "",
  ingredient: "",
  nature: null,
  code: "",
  brand: "",
  batchNumber: "",
  manufacturingDate: null,
  expiryDate: null,
  location: null,
  unitSellingPrice: "",
  description: "",
  billable: "Y",
  active: false,
  purchaseUom: "",
  salesUom: "",
  conversionFactor: "",
  subunits: "",
};
const initialError = {
  category: false,
  subCategory: false,
  name: false,
  tradeName: false,
  ingredient: false,
  nature: false,
  code: false,
  brand: false,
  batchNumber: false,
  manufacturingDate: false,
  expiryDate: false,
  location: false,

  unitSellingPrice: false,

  description: false,
};

const initialHelp = {
  category: "",
  subCategory: "",
  name: "",
  tradeName: "",
  ingredient: "",
  nature: "",
  code: "",
  brand: "",
  batchNumber: "",
  manufacturingDate: "",
  expiryDate: "",
  location: "",

  unitSellingPrice: "",

  description: "",
};

const stckEntTblHdrs = [
  "selected",
  "hsnSacCode",
  "name",
  "quantity",
  "purchaseUom",
  "landedCost",
  "cgst",
  "sgst",
  "taxes",
  "itemTotal",
  "status",
];

const StockPendingTable = ({ setPenTblVsble }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [stckValue, setStckValue] = useState(initStckVal);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [invntUpdModVsble, setInvntUpdModVsble] = useState(false);
  const [inventFiles, setInventFiles] = useState([]);
  const [delModVsble, setDelModVsble] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [prdctPrevModVsble, setPrdctPrevModVsble] = useState(false);
  const [productErrors, setProductErrors] = useState(initialError);
  const [productHelps, setProductHelps] = useState(initialHelp);
  const [productValues, setProductValues] = useState(initialValues);
  const pendingStocks = useSelector((state) => state?.clinic?.pendingStocks);
  const locationList = useSelector((state) => state?.clinic?.locationList);
  const itemSize = 10;
  const defaultUrl = `?type=pending&page=1&itemSize=${itemSize}&search=${searchValue}`;

  useEffect(() => {
    dispatch(getPendingStocksByClinic(defaultUrl));
    dispatch(getLocations());
  }, []);

  useEffect(() => {
    dispatch(
      getPendingStocksByClinic(
        `?type=pending&page=1&itemSize=${itemSize}&search=${searchValue}`
      )
    );
    setPage(1);
  }, [searchValue]);

  useEffect(() => {
    getTableList();
  }, [pendingStocks?.data]);

  const getLocationList = () => {
    if (locationList?.length === 0 || !locationList) return [];
    return locationList?.map((loc) => ({
      name: loc?.locationName,
      value: loc?.locationName,
      id: loc?.id,
    }));
  };

  const getTableList = () => {
    const list = pendingStocks?.data?.map((itm, i) => {
      const batch = itm?.stockBatch?.[0];
      return {
        ...itm,
        purchaseUom: batch?.purchaseUom,
        landedCost: Number(batch?.landedCost)?.toFixed(2),
        cgst: batch?.cgst,
        sgst: batch?.sgst,
        taxes: Number(batch?.taxes)?.toFixed(2),
        itemTotal: Number(batch?.itemTotal)?.toFixed(2),
        name: itm?.tradeName,
        i,
        apiCalled: false,
        backEndApiCalled: false,
        selected: false,
      };
    });
    setStckValue({ ...stckValue, list });
    setFilteredList(list);
  };

  const handleApiCall = () => {
    const prdct = productValues?.product;
    dispatch(showLoader());
    const product = {
      description: prdct?.description ?? "",
      packageUom: `${prdct?.packageUom}${prdct?.adminUom?.value}`,
      purchaseUom: prdct?.purchaseUom,
      dosage: prdct?.dosage ?? "",
      dosageType: prdct?.dosageType?.value ?? null,
      salesUom: prdct?.salesUom ?? "",
      conversionFactor: prdct?.conversionFactor ?? "1",
      billable: prdct?.billable ? "Y" : "N",
      subunits:
        Number(prdct?.subunits) ??
        Number(prdct?.quantity ?? 1) * Number(prdct?.conversionFactor ?? 1),
      // barCodeNo: prdct?.code ?? "",
      batchNumber: prdct?.["BatchNumber"] ?? prdct?.["batchNumber"] ?? "",
      brand: prdct?.brand ?? "",
      category: prdct?.category?.value ?? prdct?.category ?? "",
      expiryDate: moment(new Date(prdct?.expiryDate ?? prdct?.expDate)).format(
        "YYYY-MM-DD"
      ),
      mfgDate: moment(
        new Date(prdct?.mfgDate ?? prdct?.manufacturingDate ?? new Date())
      ).format("YYYY-MM-DD"),
      // prodcutName: prdct?.name ?? "",
      productName: prdct?.name ?? "",
      hsnSacCode: prdct?.hsnSacCode ?? "",
      uqcCode: prdct?.uqcCode ?? "",
      tradeName: prdct?.tradeName ?? "",
      ingredient: prdct?.ingredient ?? "",
      nature: prdct?.nature ?? "",
      type: prdct?.type ?? "",
      taxes: Number(
        getExactNumber(prdct?.taxes ?? selectedRowData?.taxes) ?? 0
      ),
      tax: Number(getExactNumber(prdct?.taxes ?? selectedRowData?.taxes) ?? 0),
      subCategory: prdct?.subCategory ?? "",
      unitSellingPrice: Number(getExactNumber(prdct?.unitSellingPrice) ?? 0),
      location: prdct?.location?.id ?? prdct?.location ?? "",
      active: true,
      // active: !prdct?.active,
      landedCost:
        Number(Number(prdct?.itemTotal) / Number(prdct?.subunits)) ??
        Number(getExactNumber(prdct?.landedCost)) ??
        0,
      internalDescription: prdct?.internalDescription,
      productVector: prdct?.productVector,
      invoiceName:
        prdct?.stockPrevName ??
        productValues?.stockPrevName ??
        selectedRowData?.name ??
        "",
      reorderLevel: prdct?.reorderLevel,
      drugSchedule: prdct?.drugSchedule?.value ?? "",
    };
    const stockObj = {
      hsnSacCode: prdct?.hsnSacCode,
      tradeName: prdct?.tradeName ?? selectedRowData?.tradeName,
      quantity: Number(
        getExactNumber(prdct?.quantity ?? selectedRowData?.quantity) ?? 1
      ),
      cgst: Number(getExactNumber(prdct?.cgst ?? selectedRowData?.cgst) ?? 0),
      sgst: Number(getExactNumber(prdct?.sgst ?? selectedRowData?.sgst) ?? 0),
      taxes: Number(
        getExactNumber(prdct?.taxes ?? selectedRowData?.taxes) ?? 0
      ),
      itemTotal: Number(
        getExactNumber(prdct?.itemTotal ?? selectedRowData?.itemTotal) ?? 0
      ),
      landedCost:
        Number(
          getExactNumber(prdct?.landedCost ?? selectedRowData?.landedCost) ?? 0
        ) ?? 0,
      barCodeNo: prdct?.code ?? "",
      status: true,
      product,
      stockId: selectedRowData?.stockId,
      reorderLevel: prdct?.reorderLevel,
      drugSchedule: prdct?.drugSchedule?.value ?? "",
    };
    if (
      !selectedRowData?.stockBatch?.[0]?.batchNo ||
      selectedRowData?.stockBatch?.[0]?.batchNo === null
    ) {
      stockObj.batchId = selectedRowData?.stockBatch?.[0]?.batchId;
    }
    try {
      dispatch(updateStocks({ stocks: [stockObj] })).then((res) => {
        if (res?.payload) {
          const reqList = stckValue?.list?.map((li, i) => {
            if (i === selectedRowData?.i) {
              return {
                ...li,
                apiCalled: true,
                backEndApiCalled: true,
                name: product?.tradeName,
              };
            }
            return li;
          });
          dispatch(getPendingStocksByClinic(defaultUrl));
          setStckValue({ ...stckValue, list: reqList });
          const fileForm = new FormData();
          inventFiles?.forEach((fle) => {
            fileForm.append("stockFiles", fle?.file);
          });
          dispatch(
            updateStockFilesById({
              stockId: selectedRowData?.stockId,
              form: fileForm,
            })
          );
          setInventFiles([]);
          setInvntUpdModVsble(false);
          setSelectedRowData(null);
          setPrdctPrevModVsble(false);
          setProductErrors(initialError);
          setProductHelps(initialHelp);
        }
      });
    } catch (err) {
      dispatch(hideLoader());
      console.log("Err");
    }
  };

  const handleUploadInventry = (data) => {
    setSelectedRowData(data);
    setInvntUpdModVsble(true);
  };

  const handleBack = () => {
    dispatch(getStocksByClinic(`?page=1&itemSize=10`));
    setPenTblVsble(false);
  };

  const handleInventImageRemove = (ind) => {
    const reqList = inventFiles
      ?.filter((fle, i) => i !== ind)
      ?.map((fle, i) => ({ ...fle, i }));
    setInventFiles(reqList);
  };

  const onInventoryUpload = () => {
    if (inventFiles?.length === 0 || !inventFiles) return;
    dispatch(showLoader());
    const form = new FormData();
    inventFiles?.forEach((fle) => {
      form.append("files", fle?.file);
    });
    if (selectedRowData?.purchaseUom?.length > 0) {
      form.append("purchase_uom", selectedRowData?.purchaseUom);
    }
    soapApi
      .post("/inventory", form)
      .then((apiRes) => {
        if (apiRes?.status === 200) {
          const reqDta = apiRes?.data?.extracted_data;
          const subunits =
            Number(selectedRowData?.quantity) *
            Number(reqDta?.ConversionFactor ?? 1);
          setPrdctPrevModVsble(true);
          setProductValues({
            ...productValues,
            stockPrevName: selectedRowData?.name,
            apiResponse: JSON.stringify(reqDta),
            product: {
              ...productValues,
              ...selectedRowData,
              ...reqDta,
              stockPrevName: selectedRowData?.name,
              quantity: selectedRowData?.quantity,
              landedCost: selectedRowData?.landedCost,
              itemTotal: selectedRowData?.itemTotal,
              packageUom: reqDta?.AdministeredTotalUnits ?? "",
              adminUom:
                administeredUOMList?.find(
                  (al) =>
                    al?.value?.toLowerCase() ===
                    reqDta?.AdministeredUOM?.toLowerCase()
                ) ?? administeredUOMList?.[0],
              active: true,
              subunits,
              conversionFactor: reqDta?.ConversionFactor,
              hsnSacCode: reqDta?.HSNCode,
              batchNumber: reqDta?.BatchNumber,
              uqcCode: reqDta?.UQCCode ?? "",
              category:
                productCategoryList?.find(
                  (prd) => prd?.value === reqDta?.Category
                ) ?? null,
              subCategory: reqDta?.SubCategory ?? null,
              ingredient: reqDta?.MajorActiveIngredients,
              nature: reqDta?.Nature ?? "",
              code: reqDta?.BarCodeNumber,
              brand: reqDta?.Brand,
              salesUom: reqDta?.Saleuom,
              manufacturingDate:
                reqDta?.ManufacturingDate &&
                reqDta?.ManufacturingDate?.length > 0
                  ? new Date(normalizeDate(reqDta?.ManufacturingDate))
                  : new Date(),
              expiryDate:
                reqDta?.ExpiryDate && reqDta?.ExpiryDate?.length > 0
                  ? new Date(normalizeDate(reqDta?.ExpiryDate))
                  : new Date(),
              location: null,
              description: reqDta?.BriefDescription,
              unitSellingPrice: getExactNumber(reqDta?.UnitSellingPrice),
              oldSellingPrice: getExactNumber(reqDta?.UnitSellingPrice),
              tradeName: reqDta?.TradeName,
              name: reqDta?.Name,
              landedCost: Number(
                (Number(selectedRowData?.itemTotal) ?? 0) / Number(subunits) ??
                  1
              ),
              dosage: reqDta?.Dosage ?? "",
              dosageType: dosageTypes?.[0],
              internalDescription: reqDta?.InternalDescription ?? "",
              productVector: reqDta?.ProductVector ?? [],
              reorderLevel: "",
              drugSchedule: null,
            },
          });
          dispatch(hideLoader());
        } else {
          dispatch(hideLoader());
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(hideLoader());
      });
  };

  const handleCloseInvntUpload = () => {
    setInvntUpdModVsble(false);
    setInventFiles([]);
  };

  const handleDeleteRow = (dta) => {
    setSelectedRowData(dta);
    setDelModVsble(true);
  };

  const handleCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedRowData(null);
  };

  const handleConfirmDelete = () => {
    dispatch(deleteStockById(selectedRowData?.stockId)).then((res) => {
      if (res?.payload) {
        dispatch(getPendingStocksByClinic(defaultUrl));
        handleCloseDelMod();
      }
    });
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = inventFiles?.length > 0 ? [...inventFiles] : [];

    const readFiles = Array.from(fileList).map((file, i) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
              i,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setInventFiles(fileLists))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onClosePrevMod = () => {
    setPrdctPrevModVsble(false);
    setSelectedRowData(null);
    setProductErrors(initialError);
    setProductHelps(initialHelp);
  };

  const handleChange = (name, value) => {
    const prdObj = { ...productValues?.product, [name]: value };
    if (name === "cgst" || name === "sgst") {
      prdObj.cgst = value;
      prdObj.sgst = value;
    }
    if (name === "conversionFactor") {
      prdObj.subunits =
        Number(value) * Number(productValues?.product?.quantity);
      prdObj.unitSellingPrice =
        Number(prdObj?.oldSellingPrice ?? prdObj?.unitSellingPrice ?? 0) /
        Number(value);
    }
    if (name === "quantity") {
      prdObj.subunits =
        Number(productValues?.product?.conversionFactor) * Number(value);
      prdObj.unitSellingPrice =
        Number(prdObj?.oldSellingPrice ?? prdObj?.unitSellingPrice ?? 0) /
        Number(value);
      prdObj.landedCost =
        Number(productValues?.product?.itemTotal) /
        (Number(productValues?.product?.conversionFactor) * Number(value));
    }
    if (name === "unitSellingPrice") {
      prdObj.oldSellingPrice = value;
    }
    setProductValues({ ...productValues, product: prdObj });
    const reqValue = typeof value === "object" ? value?.value : value;
    if (reqValue?.length > 0) {
      setProductErrors({ ...productErrors, [name]: false });
      setProductHelps({ ...productHelps, [name]: "" });
    } else {
      setProductErrors({
        ...productErrors,
        [name]: requiredFieldList?.includes(name)
          ? name === "manufacturingDate" || name === "expiryDate"
            ? false
            : true
          : false,
      });
      setProductHelps({
        ...productHelps,
        [name]: requiredFieldList?.includes(name)
          ? name === "manufacturingDate" || name === "expiryDate"
            ? ""
            : "This field is required"
          : "",
      });
    }
  };

  const handleSubmit = async () => {
    let errObj = {};
    let hlpObj = {};
    requiredFieldList?.forEach((fld) => {
      const reqValue =
        typeof productValues?.product?.[fld] === "object"
          ? productValues?.product?.[fld]?.value
          : productValues?.product?.[fld];

      if (
        reqValue === undefined ||
        reqValue === null ||
        reqValue?.length === 0 ||
        reqValue === ""
      ) {
        errObj = {
          ...errObj,
          [fld]: requiredFieldList?.includes(fld)
            ? fld === "manufacturingDate" || fld === "expiryDate"
              ? false
              : fld === "unitSellingPrice"
              ? productValues?.product?.billable === "N"
                ? false
                : true
              : true
            : false,
        };
        hlpObj = {
          ...hlpObj,
          [fld]: requiredFieldList?.includes(fld)
            ? fld === "manufacturingDate" || fld === "expiryDate"
              ? ""
              : fld === "unitSellingPrice"
              ? productValues?.billable === "N"
                ? ""
                : "This field is required"
              : "This field is required"
            : "",
        };
      } else {
        errObj = { ...errObj, [fld]: false };
        hlpObj = { ...hlpObj, [fld]: "" };
      }
    });
    setProductErrors({ ...productErrors, ...errObj });
    setProductHelps({ ...productHelps, ...hlpObj });
    if (Object.keys(errObj)?.some((val) => errObj?.[val] === true)) return;
    handleApiCall();
  };

  const handleChangePage = (e, selectedPage) => {
    dispatch(
      getPendingStocksByClinic(
        `?type=pending&page=${selectedPage}&itemSize=${itemSize}&search=${searchValue}`
      )
    );
    setPage(selectedPage);
  };

  const handleChangeCheckBox = (value, ind) => {
    const reqList = filteredList?.map((li, i) => {
      if (i === ind) {
        return { ...li, selected: value };
      }
      return li;
    });
    setFilteredList(reqList);
  };

  const handleMultiDelete = () => {
    if (!filteredList?.find((li) => li?.selected)) return;
    const stockIds = filteredList
      ?.filter((li) => li?.selected)
      ?.map((li) => li?.stockId);
    dispatch(deleteStockByIds({ stockIds })).then((res) => {
      if (res?.payload) {
        dispatch(getPendingStocksByClinic(defaultUrl));
        setPage(1);
      }
    });
  };

  const handleAction = (value) => {
    if (!filteredList?.find((li) => li?.selected)) return;
    if (value === "Delete") {
      handleMultiDelete();
    }
  };

  const handleCheckAll = () => {
    const reqSel = filteredList?.filter((li) => li?.selected === true);
    const reqList = filteredList?.map((li) => ({
      ...li,
      selected: reqSel?.length > 1 ? false : true,
    }));
    setFilteredList(reqList);
  };

  return (
    <>
      <div className="com-mar back-white pv10">
        <div className="flex-row-ali-cen w100Per">
          <div className="flex-center w100Per">
            <div className="flex-row-ali-cen">
              <div style={{ width: "400px" }}>
                <CustomTextField
                  placeholder="Search"
                  fullWidth
                  backgroundColor={AppColors.lightPink}
                  value={searchValue}
                  handleChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
              <div className="ml10">
                <SplitButton list={["Delete"]} handleClickItem={handleAction} />
              </div>
            </div>
          </div>
          <div style={{ position: "absolute", left: 70 }} onClick={handleBack}>
            <div className="flex-row-ali-cen cursor">
              <ArrowBackIcon
                sx={{ color: AppColors.appPrimary, width: 20, height: 20 }}
              />
              <Typography className="fs16 txt-semi-bold blue-color ml5">
                Back
              </Typography>
            </div>
          </div>
          <div className="pos-absolute r80">
            <Typography className="font-medium fs16">
              Total: {pendingStocks?.totalRecords}
            </Typography>
          </div>
        </div>
        <Box className="pb-40 ph20">
          <TableContainer sx={{ maxHeight: 400 }} className="mb20">
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {stckEntTblHdrs?.map((hdr, i) => (
                    <TableCell
                      style={tblGrayBack}
                      className={`table-header-text`}
                    >
                      <div
                        style={{
                          width:
                            hdr === "selected"
                              ? 10
                              : hdr === "hsnSacCode" || hdr === "name"
                              ? 120
                              : hdr === "quantity" ||
                                hdr === "cgst" ||
                                hdr === "sgst"
                              ? 50
                              : hdr === "taxes" || hdr === "itemTotal"
                              ? 80
                              : hdr === "landedCost"
                              ? 100
                              : 70,
                        }}
                      >
                        {hdr === "selected" ? (
                          <CustomCheckbox
                            checked={filteredList?.every(
                              (li) => li?.selected === true
                            )}
                            onChange={handleCheckAll}
                          />
                        ) : (
                          nmeExpan?.[hdr]
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              {filteredList?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={12} className="text-align-center h100">
                    <div className="no-rec">No records available</div>
                  </TableCell>
                </TableRow>
              )}

              <TableBody>
                {filteredList?.map((li, ind) => {
                  return (
                    <TableRow>
                      {stckEntTblHdrs?.map((hdr, i) => (
                        <TableCell key={ind + i + "tr"} component="th">
                          <div
                            style={{
                              width:
                                hdr === "selected"
                                  ? 10
                                  : hdr === "hsnSacCode" || hdr === "name"
                                  ? 120
                                  : hdr === "quantity" ||
                                    hdr === "cgst" ||
                                    hdr === "sgst"
                                  ? 50
                                  : hdr === "taxes" || hdr === "itemTotal"
                                  ? 80
                                  : hdr === "landedCost"
                                  ? 100
                                  : 70,
                            }}
                          >
                            {hdr === "selected" ? (
                              <CustomCheckbox
                                checked={li?.selected}
                                onChange={() =>
                                  handleChangeCheckBox(!li?.selected, ind)
                                }
                              />
                            ) : i === stckEntTblHdrs?.length - 1 ? (
                              <div className="flex-row-ali-cen">
                                <img
                                  src={require("../../../assets/images/png/delete.png")}
                                  className="imghw30 cursor"
                                  onClick={() => handleDeleteRow(li)}
                                />
                                {
                                  <img
                                    src={require("../../../assets/images/png/imgAttach.png")}
                                    className="imghw30 cursor ml20"
                                    onClick={() => handleUploadInventry(li)}
                                  />
                                }
                              </div>
                            ) : hdr === "name" ? (
                              <Custom3dotString
                                str={li?.[hdr]}
                                className="font-regular fs14"
                              />
                            ) : hdr === "taxes" || hdr === "itemTotal" ? (
                              Number(li?.[hdr])?.toFixed(2)
                            ) : (
                              li?.[hdr]
                            )}
                          </div>
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })}
              </TableBody>

              {Math.ceil(pendingStocks?.totalRecords / itemSize) > 1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex-end">
                        <Pagination
                          count={Math.ceil(
                            pendingStocks?.totalRecords / itemSize
                          )}
                          variant="outlined"
                          color="primary"
                          page={page}
                          onChange={handleChangePage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </Box>
      </div>

      <CustomModal
        open={invntUpdModVsble}
        onClose={handleCloseInvntUpload}
        header="Inventory Upload"
        headerCenter
        modalWidth={50}
        modal
      >
        <Grid container spacing={2}>
          {inventFiles?.length ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt20">
              <FilesWithCloseButton
                files={inventFiles}
                onClickFile={(i, fle) => handleInventImageRemove(i)}
                center
              />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomUpload
              onUploadFile={onUploadFile}
              multipleNew
              fileAccept="image/*"
              multiFiles
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-center">
              <div>
                <CustomButton
                  text="Submit"
                  smallBtn
                  onClick={onInventoryUpload}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </CustomModal>
      <CustomModal
        open={delModVsble}
        onClose={handleCloseDelMod}
        header="Delete Product"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to Delete the selected Product?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={handleConfirmDelete}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={handleCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={prdctPrevModVsble}
        onClose={onClosePrevMod}
        header="Preview"
        headerCenter
        modalWidth={100}
        modal
      >
        <div className="ph20 scroll-80vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold fs16 blue-color">
                Product Details
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomCheckbox
                label="Billable"
                checked={productValues?.product?.billable === "Y"}
                onChange={() =>
                  handleChange(
                    "billable",
                    productValues?.product?.billable === "Y" ? "N" : "Y"
                  )
                }
              />
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomCheckbox
                label="Disabled"
                checked={productValues?.product?.active}
                onChange={() =>
                  handleChange("active", !productValues?.product?.active)
                }
              />
            </Grid> */}
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Category <span className="red-color">*</span>
              </div>
              <Select
                list={productCategoryList}
                value={productValues?.product?.category}
                handleChange={(e, value) => handleChange("category", value)}
                name="category"
                search
                error={productErrors?.category}
                helperText={productHelps?.category}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Sub-Category <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="subCategory"
                fullWidth
                value={productValues?.product?.subCategory}
                error={productErrors?.subCategory}
                helperText={productHelps?.subCategory}
                handleChange={(e) =>
                  handleChange("subCategory", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">HSN Code</div>
              <CustomTextField
                name="hsnSacCode"
                fullWidth
                value={productValues?.product?.hsnSacCode}
                error={productErrors?.hsnSacCode}
                helperText={productHelps?.hsnSacCode}
                handleChange={(e) =>
                  handleChange("hsnSacCode", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Name <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="name"
                fullWidth
                value={productValues?.product?.name}
                error={productErrors?.name}
                helperText={productHelps?.name}
                handleChange={(e) => handleChange("name", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Trade Name <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="tradeName"
                fullWidth
                value={productValues?.product?.tradeName}
                error={productErrors?.tradeName}
                helperText={productHelps?.tradeName}
                handleChange={(e) =>
                  handleChange("tradeName", e?.target?.value)
                }
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Major Active Ingredients
              </div>
              <CustomTextField
                name="ingredient"
                fullWidth
                value={productValues?.product?.ingredient}
                error={productErrors?.ingredient}
                helperText={productHelps?.ingredient}
                handleChange={(e) =>
                  handleChange("ingredient", e?.target?.value)
                }
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Nature</div>
              <CustomTextField
                name="nature"
                fullWidth
                value={productValues?.product?.nature}
                error={productErrors?.nature}
                helperText={productHelps?.nature}
                handleChange={(e) => handleChange("nature", e?.target?.value)}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Bar Code number
              </div>
              <CustomTextField
                name="code"
                fullWidth
                value={productValues?.product?.code}
                error={productErrors?.code}
                helperText={productHelps?.code}
                handleChange={(e) => handleChange("code", e?.target?.value)}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Brand</div>
              <CustomTextField
                name="brand"
                fullWidth
                value={productValues?.product?.brand}
                error={productErrors?.brand}
                helperText={productHelps?.brand}
                handleChange={(e) => handleChange("brand", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Reorder level</div>
              <CustomTextField
                name="reorderLevel"
                fullWidth
                value={productValues?.product?.reorderLevel}
                error={productErrors?.reorderLevel}
                helperText={productHelps?.reorderLevel}
                handleChange={(e) =>
                  handleChange("reorderLevel", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Drug Schedule</div>
              <Select
                list={drugScheduleList}
                value={productValues?.product?.drugSchedule}
                handleChange={(e, value) => handleChange("drugSchedule", value)}
                name="drugSchedule"
                search
                error={productErrors?.drugSchedule}
                helperText={productHelps?.drugSchedule}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Brief Description of the Product
              </div>
              <CustomTextField
                name="description"
                fullWidth
                value={productValues?.product?.description}
                error={productErrors?.description}
                helperText={productHelps?.description}
                handleChange={(e) =>
                  handleChange("description", e?.target?.value)
                }
                multiline
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold fs16 blue-color">
                Stock Details
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Batch Number</div>
              <CustomTextField
                name="batchNumber"
                fullWidth
                value={productValues?.product?.batchNumber}
                error={productErrors?.batchNumber}
                helperText={productHelps?.batchNumber}
                handleChange={(e) =>
                  handleChange("batchNumber", e?.target?.value)
                }
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Mfg Date</div>
              <CustomTextField
                fullWidth
                value={productValues?.product?.manufacturingDate}
                error={productErrors?.manufacturingDate}
                helperText={productHelps?.manufacturingDate}
                handleChange={(e) =>
                  handleChange("manufacturingDate", e?.target?.value)
                }
                mobileDate
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Expiry Date</div>
              <CustomTextField
                fullWidth
                value={productValues?.product?.expiryDate}
                error={productErrors?.expiryDate}
                helperText={productHelps?.expiryDate}
                handleChange={(e) =>
                  handleChange("expiryDate", e?.target?.value)
                }
                mobileDate
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Location <span className="red-color">*</span>
              </div>
              <Select
                list={getLocationList()}
                value={productValues?.product?.location}
                handleChange={(e, value) => handleChange("location", value)}
                name="location"
                search
                error={productErrors?.location}
                helperText={productHelps?.location}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Purchase UOM</div>
              <CustomTextField
                name="purchaseUom"
                fullWidth
                value={productValues?.product?.purchaseUom}
                error={productErrors?.purchaseUom}
                helperText={productHelps?.purchaseUom}
                handleChange={(e) =>
                  handleChange("purchaseUom", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Sales UOM</div>
              <CustomTextField
                name="salesUom"
                fullWidth
                value={productValues?.product?.salesUom}
                error={productErrors?.salesUom}
                helperText={productHelps?.salesUom}
                handleChange={(e) => handleChange("salesUom", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                UOM Conversion Factor
              </div>
              <CustomTextField
                name="conversionFactor"
                fullWidth
                value={productValues?.product?.conversionFactor}
                error={productErrors?.conversionFactor}
                helperText={productHelps?.conversionFactor}
                handleChange={(e) =>
                  handleChange("conversionFactor", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Unit Qty {/* Quantity */}
                <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="quantity"
                fullWidth
                value={productValues?.product?.quantity}
                error={productErrors?.quantity}
                helperText={productHelps?.quantity}
                handleChange={(e) => handleChange("quantity", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Subunit Qty {/* Subunits */}
                <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="subunits"
                fullWidth
                value={productValues?.product?.subunits}
                error={productErrors?.subunits}
                helperText={productHelps?.subunits}
                handleChange={(e) => handleChange("subunits", e?.target?.value)}
                disabled
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Administered UOM
              </div>
              <div className="flex-row">
                <div className="w60Per pr10">
                  <CustomTextField
                    name="packageUom"
                    fullWidth
                    value={productValues?.product?.packageUom}
                    error={productErrors?.packageUom}
                    helperText={productHelps?.packageUom}
                    handleChange={(e) =>
                      handleChange("packageUom", e?.target?.value)
                    }
                    type="number"
                  />
                </div>
                <div className="w40Per">
                  <Select
                    list={administeredUOMList}
                    value={productValues?.product?.adminUom}
                    handleChange={(e, value) => handleChange("adminUom", value)}
                    name="adminUom"
                    search
                    error={productErrors?.adminUom}
                    helperText={productHelps?.adminUom}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Dosage</div>
              <div className="flex-row">
                <div className="w60Per pr10">
                  <CustomTextField
                    name="dosage"
                    // label="Dosage"
                    fullWidth
                    value={productValues?.product?.dosage}
                    error={productErrors?.dosage}
                    helperText={productHelps?.dosage}
                    handleChange={(e) =>
                      handleChange("dosage", e?.target?.value)
                    }
                    type="number"
                    endIcon
                    inputIcon={productValues?.product?.adminUom?.name ?? ""}
                  />
                </div>
                <div className="w40Per">
                  <Select
                    list={dosageTypes}
                    value={productValues?.product?.dosageType}
                    handleChange={(e, value) =>
                      handleChange("dosageType", value)
                    }
                    name="dosageType"
                    search
                    error={productErrors?.dosageType}
                    helperText={productHelps?.dosageType}
                  />
                </div>
              </div>
            </Grid>
            {productValues?.product?.billable === "Y" ? (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography className="font-bold fs16 blue-color">
                    Price & Taxes
                  </Typography>
                </Grid>

                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Selling Price {/* Unit Selling Price (MRP){" "} */}
                    <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="unitSellingPrice"
                    fullWidth
                    value={productValues?.product?.unitSellingPrice}
                    error={productErrors?.unitSellingPrice}
                    helperText={productHelps?.unitSellingPrice}
                    handleChange={(e) =>
                      handleChange("unitSellingPrice", e?.target?.value)
                    }
                  />
                  <div className="fs12 gray-color txt-regular mt5">
                    Price is for subunits
                  </div>
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    CGST (%) <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="cgst"
                    fullWidth
                    value={productValues?.product?.cgst}
                    error={productErrors?.cgst}
                    helperText={productHelps?.cgst}
                    handleChange={(e) => handleChange("cgst", e?.target?.value)}
                    type="number"
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    SGST (%) <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="sgst"
                    fullWidth
                    value={productValues?.product?.sgst}
                    error={productErrors?.sgst}
                    helperText={productHelps?.sgst}
                    handleChange={(e) => handleChange("sgst", e?.target?.value)}
                    type="number"
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Item Total (Buying) <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="itemTotal"
                    fullWidth
                    value={productValues?.product?.itemTotal}
                    error={productErrors?.itemTotal}
                    helperText={productHelps?.itemTotal}
                    handleChange={(e) =>
                      handleChange("itemTotal", e?.target?.value)
                    }
                    disabled
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Landed Cost (Buying)
                    {/* <span className="red-color">*</span> */}
                  </div>
                  <CustomTextField
                    name="landedCost"
                    fullWidth
                    value={Number(productValues?.product?.landedCost)?.toFixed(
                      2
                    )}
                    error={productErrors?.landedCost}
                    helperText={productHelps?.landedCost}
                    handleChange={(e) =>
                      handleChange("landedCost", e?.target?.value)
                    }
                    disabled
                  />
                </Grid>
              </>
            ) : null}
          </Grid>

          <div className="mt30">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div className="flex1-end">
                <div className="flex-row-ali-cen">
                  <div className="mr10">
                    <CustomButton
                      text="Cancel"
                      textBtn
                      onClick={onClosePrevMod}
                      color={AppColors.red}
                    />
                  </div>
                  <div className="ml10">
                    <CustomButton text="Submit" onClick={handleSubmit} />
                  </div>
                </div>
              </div>
            </Grid>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default StockPendingTable;
